export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/api-integration-hub/:pageId',
        component: () => import('@/views/page/company/api-integration-hub/List.vue'),
        name: 'api-integration-hub',
        meta: {
            requiresAuth: true
        }
    }
]
